import { define } from '@components/Component.js'
import { h } from '@core/dom.js'

const stars = (rating, size = '1rem') => {
    const wrap = h('span', { style: `font-size:${size};letter-spacing:2px` })
    for (let i = 1; i <= 5; i++) {
        wrap.appendChild(h('span', {
            style: `color:${i <= rating ? '#f59e0b' : '#d1d5db'}`
        }, '★'))
    }
    return wrap
}

define('BusinessReviews', ({ businessId }) => {
    const root = h('div', { className: 'biz-reviews' })

    const content = h('div', {})
    root.appendChild(h('h3', { className: 'biz-reviews__title' }, 'Reseñas de clientes'))
    root.appendChild(content)

    content.innerHTML = '<p style="color:#94a3b8;padding:1rem 0">⏳ Cargando reseñas…</p>'

    async function load() {
        try {
            const res = await fetch(`/api/reviews.php?id=${businessId}`)
            const text = await res.text()
            let data
            try { data = JSON.parse(text) } catch { throw new Error('local') }

            content.innerHTML = ''

            const summary = h('div', { className: 'biz-reviews__summary' },
                h('div', { className: 'biz-reviews__avg' },
                    h('span', { className: 'biz-reviews__avg-num' }, data.avg ? String(data.avg) : '—'),
                    stars(Math.round(data.avg || 0), '1.2rem'),
                    h('span', { className: 'biz-reviews__avg-count' }, `${data.count} reseña${data.count !== 1 ? 's' : ''}`)
                )
            )
            content.appendChild(summary)

            content.appendChild(buildForm())

            if (data.reviews && data.reviews.length) {
                const list = h('div', { className: 'biz-reviews__list' })
                data.reviews.forEach(r => {
                    list.appendChild(h('div', { className: 'biz-reviews__item' },
                        h('div', { className: 'biz-reviews__item-head' },
                            h('strong', {}, r.name),
                            stars(r.rating, '.9rem'),
                            h('span', { className: 'biz-reviews__date' }, r.date)
                        ),
                        r.comment ? h('p', { className: 'biz-reviews__comment' }, r.comment) : null
                    ))
                })
                content.appendChild(list)
            }
        } catch {
            content.innerHTML = ''
            content.appendChild(buildForm())
            content.appendChild(h('p', { style: 'color:#94a3b8;font-size:.85rem;margin-top:1rem' },
                'Las reseñas están disponibles en el sitio publicado.'))
        }
    }

    function buildForm() {
        let selectedRating = 0

        const starsInput = h('div', { className: 'biz-reviews__stars-input' })
        const starBtns = []
        for (let i = 1; i <= 5; i++) {
            const btn = h('button', {
                type: 'button',
                className: 'biz-reviews__star-btn',
                title: `${i} estrella${i > 1 ? 's' : ''}`
            }, '★')
            btn.addEventListener('click', () => {
                selectedRating = i
                starBtns.forEach((b, idx) => {
                    b.style.color = idx < i ? '#f59e0b' : '#d1d5db'
                })
            })
            starBtns.push(btn)
            starsInput.appendChild(btn)
        }

        const nameInp = h('input', {
            className: 'biz-reviews__input',
            type: 'text',
            placeholder: 'Tu nombre',
            maxLength: 60
        })
        const commentInp = h('textarea', {
            className: 'biz-reviews__textarea',
            placeholder: 'Tu comentario (opcional)',
            rows: 3,
            maxLength: 500
        })
        const submitBtn = h('button', {
            className: 'biz-reviews__submit',
            type: 'button'
        }, 'Enviar reseña')
        const msg = h('p', { className: 'biz-reviews__msg', style: 'display:none' })

        submitBtn.addEventListener('click', async () => {
            const name = nameInp.value.trim()
            if (!name) { msg.textContent = '⚠️ Escribe tu nombre'; msg.style.display = ''; return }
            if (!selectedRating) { msg.textContent = '⚠️ Selecciona una calificación'; msg.style.display = ''; return }

            submitBtn.disabled = true
            submitBtn.textContent = '⏳ Enviando…'
            msg.style.display = 'none'

            try {
                const res = await fetch('/api/reviews.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        businessId,
                        name,
                        rating: selectedRating,
                        comment: commentInp.value.trim()
                    })
                })
                const data = await res.json()
                if (!data.ok) throw new Error(data.error || 'Error')
                load()
            } catch (err) {
                msg.textContent = `❌ ${err.message}`
                msg.style.display = ''
                submitBtn.disabled = false
                submitBtn.textContent = 'Enviar reseña'
            }
        })

        return h('div', { className: 'biz-reviews__form' },
            h('h4', { className: 'biz-reviews__form-title' }, 'Deja tu reseña'),
            h('div', { className: 'biz-reviews__form-row' },
                h('label', {}, 'Calificación'),
                starsInput
            ),
            nameInp,
            commentInp,
            msg,
            submitBtn
        )
    }

    load()
    return root
})
